import React from "react"
import { TextField, Dialog, FlatButton, Chip } from "material-ui"
import AccountStore from "../../stores/AccountStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import strings from "../../localization/strings"
import * as utils from "../../helpers/utils"
import * as equipmentActions from "../../actions/EquipmentActions"
import autobind from "class-autobind"
import { IEquipmentDocument } from "../../models"
import AppStateStore from "../../stores/AppStateStore"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
const externalIdRegExp = /^[a-zA-Z0-9-]*$/
interface IProps {
    onClose(): void
}
interface IState {
    name: string
    externalId: string
    nameErrorText: string
    externalIdErrorText: string
    disableButtons: boolean
}

export default class AddEquipment extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            name: "",
            externalId: "",
            nameErrorText: "",
            externalIdErrorText: "",
            disableButtons: false
        }
        autobind(this)
    }

    detectEnter(event) {
        event.keyCode === 13 &&
            this.handleRequestSave()
    }

    handleRequestSave() {
        this.setState({ disableButtons: true })
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() => {
            this.checkValidate().then(res => {
                if (res) {
                    this.props.onClose()
                    equipmentActions.addEquipment(this.createEquipment(), () =>
                        AppStateStore.setProgressSnackbarContent(strings.Equipment_created_successfully)
                    )
                }
                else {
                    AppStateStore.setProgressSnackbarContent("")
                    this.setState({ disableButtons: false })
                }
            })
        }, 1000)
    }

    handleRequestAddAnother() {
        this.setState({ disableButtons: true })
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() => {
            this.checkValidate().then(res => {
                if (res) {
                    equipmentActions.addEquipment(this.createEquipment())
                    this.setState({
                        disableButtons: false,
                        name: "",
                        externalId: ""
                    })
                    AppStateStore.setProgressSnackbarContent(strings.Equipment_created_successfully)
                }
                else {
                    AppStateStore.setProgressSnackbarContent("")
                    this.setState({ disableButtons: false })
                }
            })
        }, 1000)
    }

    createEquipment() {
        const equipment: IEquipmentDocument = {
            Id: utils.guid(),
            AccountId: AccountStore.getCurrentAccount().Id,
            DefaultHierarchyItemId: HierarchySettingsStore.getGlobalLevelItemFilterId(),
            Name: this.state.name,
            ExternalId: this.state.externalId
        }
        return equipment
    }

    checkValidate() {
        let returnVal = true
        const nameLength = this.state.name.trim().length

        if (nameLength === 0) {
            this.setState({ nameErrorText: strings.NameRequired })
            returnVal = false
        } else {
            this.setState({ nameErrorText: "" })
        }

        if (this.state.externalId.match(externalIdRegExp)) {
            this.setState({ externalIdErrorText: "" })
        } else {
            this.setState({ externalIdErrorText: "Invalid ID format." })
            returnVal = false
        }

        if (!this.state.externalId.length) {
            returnVal = false
            this.setState({ externalIdErrorText: (!this.state.externalId.length && strings.Provide_External_ID) || this.state.externalIdErrorText })
            return new Promise((fulfill, reject) => {
                fulfill(returnVal)
            })
        }

        const _this = this
        const accId = AccountStore.getCurrentAccount().Id
        return equipmentActions.equipmentExternalIdExists(accId, this.state.externalId).then(res => {
            if (res.data) {
                _this.setState({ externalIdErrorText: strings.External_ID_must_be_unique })
                returnVal = false
            }
            return returnVal
        })
    }

    render() {
        return (
            <Dialog
                open
                title={strings.ADD_EQUIPMENT}
                actions={[
                    <FlatButton
                        key="another"
                        label={strings.Add_Another}
                        primary
                        style={{ float: "left" }}
                        labelStyle={{ textDecoration: "underline" }}
                        onTouchTap={this.handleRequestAddAnother}
                        disabled={this.state.disableButtons}
                    />,
                    <FlatButton
                        key="cancel"
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.onClose}
                        disabled={this.state.disableButtons}
                    />,
                    <FlatButton
                        key="add"
                        label={strings.ADD_EQUIPMENT}
                        primary
                        onTouchTap={this.handleRequestSave}
                        disabled={this.state.disableButtons}
                    />
                ]}
            >
                <div style={{ width: "100%" }}>
                    <div style={{ height: 60, verticalAlign: "top", marginRight: 45, marginBottom: 10 }}>
                        <TextField
                            autoFocus
                            floatingLabelText={strings.Name}
                            value={this.state.name}
                            onChange={e =>
                                this.setState({
                                    name: e.target.value,
                                    nameErrorText: ""
                                })
                            }
                            onKeyUp={this.detectEnter}
                            errorText={this.state.nameErrorText}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div style={{ height: 60, verticalAlign: "top", marginRight: 45, marginBottom: 10 }}>
                        <TextField
                            floatingLabelText={strings.External_ID}
                            value={this.state.externalId}
                            onChange={e => {
                                this.setState({ externalId: e.target.value })
                                e.target.value.match(externalIdRegExp) ?
                                    this.setState({ externalIdErrorText: "" }) :
                                    this.setState({ externalIdErrorText: "Invalid ID format." })
                            }}
                            onKeyUp={this.detectEnter}
                            errorText={this.state.externalIdErrorText}
                            style={{ width: "100%" }}
                            maxLength="15"
                        />
                    </div>
                </div>
                <div style={{ height: 72, marginTop: "20px", width: "100%" }}>
                    <div style={{ marginTop: 14, display: "inline-block", verticalAlign: "top", width: "45%" }}>
                        <span style={{ display: "inline-block" }}>
                            <div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298039)" }}>
                                {strings.Home_Hierarchy}
                            </div>
                            <Chip style={{ cursor: "pointer", margin: 2, height: 35 }}>
                                {HierarchySettingsStore.getGlobalLevelItemFilterId() ?
                                    <span>
                                        <b>{hierarchyHelper.getHierarchyDefinitionNameByHierarchyId(HierarchySettingsStore.getGlobalLevelItemFilterId())}</b> {hierarchyHelper.getHierarchyItemNameByHierarchyId(HierarchySettingsStore.getGlobalLevelItemFilterId())}
                                    </span> :
                                    <span>
                                        <b>{strings.Account}</b> {AccountStore.getCurrentAccount().Name}
                                    </span>
                                }
                            </Chip>
                        </span>
                    </div>
                </div>
            </Dialog>
        )
    }
}
